import React from "react";
import Currency from "./currency";
import { VarianceType } from "./remittanceV2Constants";

/**
 * This component will render the amount color based on the type field of the amount
 * i.e. Short = red and Excess = green
 * @param  props 
 * @returns 
 */
const VarianceAmount = (props) => {
    const amount = {...props.amount};
    if (props.type === VarianceType.SHORT) {
        amount.value = -1 * amount.value;
    }

    return (<Currency isVariance={true} amount={amount} />);
}

export default VarianceAmount;


// WEBPACK FOOTER //
// ./src/component/common/varianceAmount.js